import { toastError } from '../utils/toastMessage';
import API from '../utils/API';

export const getAllMealTypesSuccess = (data) => {
  return {
    type: 'GET_ALL_MEAL_TYPES_SUCCESS',
    data,
  };
};

export const getAllMealTypes = () => {
  return (dispatch) => {
    API.get('/dishes/types/get')
      .then((response) => {
        dispatch(getAllMealTypesSuccess(response.data.data.types));
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/getAllMealTypes.js